import React, { useContext } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import PropTypes from 'prop-types';
import { isDesktop } from "react-device-detect";

//ads
import Caja3 from '../../ads/Caja3';

//context
import GalleryContext from '../../context/GalleryContext';

//components
import Button from '../common/Button';
import EmptySpace from '../common/EmptySpace';

const GalleryItem = props => {

    const { idPhoto } = props;    
    const { dataGallery } = useContext(GalleryContext);    
    const { urlEspecialVideos, epigraph, gallery, qryStrStart, queryStringText, urlEspecial } = dataGallery;  
    
    const galleryItem = gallery[idPhoto];
    const { backgroundColorItem, buttonPrevClass, id, itemTitle } = galleryItem;
    
    const firstItem = 1;
    const galleryKeys = Object.keys(gallery);
    const posCurrentItem = galleryKeys.indexOf(idPhoto);

    const findItemByPosition = pos => galleryKeys[pos];

    const prevItem = (id === firstItem) ? urlEspecial : `${urlEspecial}${qryStrStart}${queryStringText}=${findItemByPosition(posCurrentItem - 1)}`;
    var nextItem = `${urlEspecial}${qryStrStart}${queryStringText}=${findItemByPosition(posCurrentItem + 1)}`;
    var button2Text = 'Siguiente';

    if (id === galleryKeys.length){
        nextItem = urlEspecial;
        button2Text = 'Inicio';
    }

    return (
        <section className="mx-auto container-titular" style={{ backgroundColor: backgroundColorItem }}>
            <article className="mx-auto gallery-item">
                <LazyLoadImage
                    alt={itemTitle}
                    className="img-fluid"
                    effect="blur"
                    src={`${urlEspecialVideos}img/${id}.jpg`}
                />                 
                <h1 className="d-none">{itemTitle}</h1>
                <p className="d-none">{epigraph}</p>
            </article>                
            <section className="d-flex justify-content-start mt-0 mt-md-3 mb-5 mx-auto px-4 px-md-5 gallery-item">
                <section className="me-2">
                    <Button 
                        classButton={buttonPrevClass}
                        text="Anterior"
                        url={prevItem}
                    />
                </section>
                <section className="ms-2">
                    <Button 
                        classButton="btn-next"
                        text={button2Text}
                        url={nextItem}
                    />
                </section>
            </section>
            <section className="content-msgs">
                {!isDesktop && <Caja3 />}        
            </section>  
            <EmptySpace />
        </section>
    )
}

export default GalleryItem;

GalleryItem.propTypes = {
    idPhoto: PropTypes.string.isRequired,
}